
































































































































import {
  faGlobe,
  faMapMarkerAlt,
  faPhone,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { mapGetters } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import CContactForm from '~/components/shared/configurable/CContactForm.vue'
import CDirectionsButton from '~/components/shared/configurable/map/CDirectionsButton.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CAvatar,
    CContactForm,
    CDirectionsButton
  },
  props: {
    agentProfile: { type: Object as PropType<any>, required: true },
    sticky: { type: Boolean, default: false },
    halfSize: { type: Boolean, default: false }
  },
  data() {
    return {
      showContactModal: false
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_SEARCH_NS, {
      inPlotSearch: 'inPlotSearch'
    }),
    icons() {
      return {
        location: faMapMarkerAlt,
        phone: faPhone,
        website: faGlobe,
        close: faTimes
      }
    },
    directionUrl(): string | null {
      if (this.agentProfile?.geolocation?.length) {
        const [lat, lng] = this.agentProfile.geolocation
        return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
      }
      return null
    },
    phone1() {
      const { telephone1 } = this.agentProfile
      if (telephone1 && !telephone1.dontShowToPublic) {
        return telephone1.telephone
      }
      return null
    },
    phone2() {
      const { telephone2 } = this.agentProfile
      if (telephone2 && !telephone2.dontShowToPublic) {
        return telephone2.telephone
      }
      return null
    },
    contactFormCols() {
      return {
        cols: '12',
        md: '12',
        lg: '12',
        xl: '12'
      }
    },
    url(): string {
      return `/api/agents/${this.agentProfile.id}/contact/`
    },
    siteLabel() {
      if (this.inPlotSearch) {
        return 'Plot'
      }
      return 'Car'
    },
    tableProfileData() {
      return [
        {
          key: this.$i18n.t('address'),
          value: this.agentProfile.address || '-'
        },
        {
          key: this.$i18n.t('telephone') + '1',
          value: this.phone1 || '-',
          code: this.agentProfile.telephone1?.code
        },
        {
          key: this.$i18n.t('telephone') + '2',
          value: this.phone2 || '-',
          code: this.agentProfile.telephone2?.code
        },
        {
          key: this.$i18n.t('email'),
          value: this.agentProfile.email || '-',
          email: true
        },
        {
          key: this.$i18n.t('site'),
          value: this.agentProfile.website,
          link: true
        },
        {
          key: `${this.$i18n.t('site')} ${this.siteLabel}`,
          value: this.agentProfile.internal_page,
          link: true
        }
      ]
    }
  }
})
